/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { subjectTypes } from '../../@types/entities/subjects.entity';

interface propTypes {
  $color: 10 | 20 | 30 | 40 | 50;
  $subject: subjectTypes | string;
}

export const Container = styled.section<propTypes>`
  ${({ theme }) => theme.spacing.articleBody};
  margin: 1em 0;

  .highlight-content {
    background-color: #A648FF;
    padding: 24px 0;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  p, ul, ol {
    padding: 0 179px;

    @media (max-width: 1440px) {
      padding: 0 170px;
    }

    @media (max-width: 999px) {
      padding: 0 92px;
    }

    @media (max-width: 600px) {
      padding: 0 20px;
    }

    margin-top: 0;
  }

  .listaBullets li::marker, .listaNumerica li::marker {
    color: #fff !important;
  }

  p:first-of-type{
          display: none;
      }
`;
